import React, { ChangeEvent, FC } from 'react'
import { IInputBlockProps, INumberInputProps } from '../Input.types'
import { HelpText, InputBase, Label, Required, Root } from '../Input'
import css from '../Input.module.scss'

const Div = (props: IInputBlockProps) => (
  <div className={css.numberWidth} {...props} />
)

const IconPlus = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8333 6.83333H6.83334V11.8333H5.16667V6.83333H0.166672V5.16666H5.16667V0.166664H6.83334V5.16666H11.8333V6.83333Z"
      fill="#175EDC"
    />
  </svg>
)

const IconMinus = () => (
  <svg
    width="12"
    height="2"
    viewBox="0 0 12 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8333 1.83333H0.166672V0.166664H11.8333V1.83333Z"
      fill="#175EDC"
    />
  </svg>
)

const NUMERICAL_REGEX = /^-?[1-9]\d*$/

const NumberInput: FC<INumberInputProps> = ({
  className,
  disabled,
  helpText,
  hideButtons,
  invalid,
  isBlock,
  required,
  label,
  max,
  min,
  step = 1,
  value,
  onChange,
  ...passingProps
}) => {
  const hasMax = max !== undefined
  const hasMin = min !== undefined
  const inputValue =
    !Number.isNaN(value) && value !== undefined && value !== null ? +value : 0

  const handlePlus = () => {
    if (!hasMax || inputValue < max) {
      onChange(inputValue + step)
    }
  }
  const handleMinus = () => {
    if (!hasMin || inputValue > min) {
      onChange(inputValue - step)
    }
  }

  const handleInputChange = ({
    target,
  }: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (target.value === '') return onChange(undefined)

    if (!NUMERICAL_REGEX.test(target.value) && target.value !== '') {
      return
    }
    const numberValue = Number(target.value)
    if (hasMax && numberValue > +max) {
      return
    }
    if (hasMin && numberValue < +min) {
      return
    }

    onChange?.(numberValue)
  }

  const isInvalid =
    invalid || (hasMax && inputValue > max) || (hasMin && inputValue < min)

  const Wrap = label || helpText ? Root : Div

  return (
    <Wrap
      $isBlock={isBlock}
      className={label || helpText ? className : undefined}
    >
      {label && (
        <Label>
          {label}
          {required ? <Required /> : null}
        </Label>
      )}

      <div className={`${css.numberFlex} ${isBlock ? css.isBlock : ''}`}>
        {!hideButtons && (
          <button
            className={css.numberButtonPlus}
            type="button"
            disabled={disabled || (hasMin && inputValue <= min)}
            aria-label="minusBtn"
            onClick={handleMinus}
          >
            <IconMinus />
          </button>
        )}

        {/** @ts-ignore */}
        <InputBase
          className={`${css.styledNumberInput} ${isBlock ? css.isBlock : ''}`}
          type="number"
          disabled={disabled}
          // @ts-ignore
          invalid={isInvalid}
          value={value}
          required={required}
          {...passingProps}
          onChange={handleInputChange}
        />

        {!hideButtons && (
          <button
            className={css.numberButtonPlus}
            type="button"
            disabled={disabled || (hasMax && inputValue >= max)}
            aria-label="plusBtn"
            onClick={handlePlus}
          >
            <IconPlus />
          </button>
        )}
      </div>

      {helpText && <HelpText>{helpText}</HelpText>}
    </Wrap>
  )
}

export default NumberInput
